<template>
  <div>
    <!-- -------------------------Evaluaciones "Clases ya cursadas" Estudiante------------------------- -->
    <Card
      v-if="user && user.group_names.includes('ESTUDIANTES')"
      class="dashboard-card"
      :hide_title="hide_title"
    >
      <template v-slot:title>
        <div class="container-title-my-classes">
          <div>
            <b-icon class="card-header-icon" icon="journal-text"></b-icon>
            {{ $t("dashboard.dashboardView.pastClasses") }}
          </div>
        </div>
      </template>
      <template v-slot:content>
        <template v-if="institution && institution.kl_assessment">
          <template
            v-if="
              user.group_names.includes('ESTUDIANTES') &&
              sections_student.length > 0
            "
          >
            <b-table-simple
              borderless
              small
              hover
              sticky-header="400px"
              class="border-table"
            >
              <b-thead>
                <b-tr>
                  <b-th class="primary-cell-my-classes" style="width: 30%">{{
                    $getVisibleNames(
                      "mesh.egressprofilematter",
                      false,
                      "Asignatura"
                    )
                  }}</b-th>
                  <b-th class="primary-cell-my-classes" style="width: 15%">{{
                    $getVisibleNames("mesh.campus", false, "Sede")
                  }}</b-th>
                  <b-th class="primary-cell-my-classes" style="width: 15%">
                    {{ $getVisibleNames("teaching.section", false, "Sección") }}
                  </b-th>
                  <b-th class="primary-cell-my-classes" style="width: 15%">{{
                    $getVisibleNames("mesh.period", false, "Periodo")
                  }}</b-th>
                  <b-th class="primary-cell-my-classes" style="width: 25%">
                    {{ $t("dashboard.dashboardView.teachers") }}
                  </b-th>
                  <b-th class="primary-cell-my-classes">
                    {{ $t("dashboard.dashboardView.options") }}
                  </b-th>
                </b-tr>
              </b-thead>

              <b-tbody>
                <template v-for="section in sections_student">
                  <b-tr
                    v-for="sectionMatterStudent in section.sections"
                    :key="
                      'past-section-student-period-' +
                      section.period_id +
                      '-section-' +
                      sectionMatterStudent.id
                    "
                  >
                    <!-- Nombre de la Asignatura -->
                    <b-td class="secondary-cell-my-classes">
                      <div class="d-flex container-matter-my-classes">
                        <div
                          v-if="
                            sectionMatterStudent.egress_profile_matter_id !=
                            null
                          "
                          class="mr-0 div-href-test"
                          v-b-tooltip.v-secondary.top.noninteractive="{
                            title:
                              institution &&
                              institution.internal_use_id == 'duoc.cl'
                                ? $t('dashboard.dashboardView.goToPAStudent')
                                : $t(
                                    'dashboard.dashboardView.goToEntityProgram',
                                    {
                                      entity: $getVisibleNames(
                                        'manual.matter_program',
                                        false,
                                        'Programa de Asignatura'
                                      ),
                                    }
                                  ),
                            boundary: 'viewport',
                          }"
                          @click="
                            redirectToPA(
                              sectionMatterStudent.egress_profile_matter_id
                            )
                          "
                        >
                          {{ sectionMatterStudent.matter_code }} -
                          {{ sectionMatterStudent.matter_name }}
                        </div>
                        <div v-else class="mr-0">
                          {{ sectionMatterStudent.matter_code }} -
                          {{ sectionMatterStudent.matter_name }}
                        </div>
                      </div>
                    </b-td>
                    <!-- Nombre del Campus -->
                    <b-td class="secondary-cell-my-classes text-left">
                      {{ sectionMatterStudent.campus_name }}
                    </b-td>
                    <!-- Nombre de la Seccion -->
                    <b-td class="secondary-cell-my-classes text-left">
                      {{ sectionMatterStudent.name }}
                    </b-td>
                    <!-- Nombre del Periodo -->
                    <b-td class="secondary-cell-my-classes text-left">
                      {{ section.period_name }}
                    </b-td>
                    <b-td class="secondary-cell-my-classes text-left">
                      {{ sectionMatterStudent.professors.join(", ") }}
                    </b-td>
                    <b-td
                      class="secondary-cell-my-classes noprint"
                      style="text-align: -webkit-center"
                    >
                      <!-- Botón 3 puntos que abre popover -->
                      <div>
                        <ButtonWrapper :item_id="sectionMatterStudent.id">
                          <template v-slot:btn-slot>
                            <div class="container-btn-three-dots">
                              <b-button
                                variant="secondary"
                                @click="
                                  redirectToEvaluationTeacher(
                                    sectionMatterStudent.id
                                  )
                                "
                                class="btn-popover-my-classes w-100"
                                :class="{
                                  'mb-2':
                                    institution &&
                                    (institution.uses_ipss_assessment == true ||
                                      institution.internal_use_id == 'duoc.cl'),
                                }"
                              >
                                {{
                                  $getVisibleNames(
                                    "evaluations2.evaluation",
                                    true,
                                    "Evaluaciones"
                                  )
                                }}
                              </b-button>
                              <b-button
                                v-if="
                                  institution && institution.show_kl_reports
                                "
                                variant="secondary"
                                class="btn-popover-my-classes w-100"
                                @click="
                                  redirectToAssessmentStudent(
                                    sectionMatterStudent.id
                                  )
                                "
                                >{{ $t("dashboard.dashboardView.assessment") }}
                              </b-button>
                            </div>
                          </template>
                        </ButtonWrapper>
                      </div>
                    </b-td>
                  </b-tr>
                </template>
              </b-tbody>
            </b-table-simple>
          </template>
          <template
            v-if="
              user.group_names.includes('ESTUDIANTES') &&
              sections_student.length == 0
            "
          >
            <div class="text-left">
              {{
                $t("dashboard.dashboardView.noEntityToShow", {
                  entity: $getVisibleNames(
                    "teaching.section",
                    true,
                    "Secciones"
                  ),
                })
              }}
            </div>
          </template>
        </template>
        <template v-else>
          <div class="text-left">
            <span>{{ $t("dashboard.dashboardView.moduleNotEnabled") }}</span>
          </div>
        </template>
      </template>
    </Card>
  </div>
</template>

<script>
// import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "CurrentSectionStudent",
  components: {
    Card: () => import("@/components/users/Card"),
    ButtonWrapper: () => import("@/components/reusable/ButtonWrapper"),
  },
  props: {
    hide_title: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sections_student: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
    }),
  },
  methods: {
    redirectToAssessmentStudent(id) {
      this.$router.push({
        name: "AssessmentStudentView",
        params: {
          section_id: id,
        },
      });
    },
    redirectToEvaluationTeacher(id) {
      this.$router.push({
        name: "EvaluateeEvaluationsListView",
        params: {
          section_id: id,
        },
      });
    },
    redirectToPA(egress_profile_matter_id) {
      if (this.institution && this.institution.internal_use_id == "duoc.cl")
        this.$router.push({
          name: "LearningSuitcaseStudentView",
          params: {
            egress_profile_matter_id: egress_profile_matter_id,
          },
        });
      else {
        this.$router.push({
          name: "MatterProgramView",
          params: {
            matter_id: egress_profile_matter_id,
          },
        });
      }
    },
    getSectionStudent() {
      if (
        this.user &&
        this.user.group_names.includes("ESTUDIANTES") &&
        this.sections_student.length == 0 &&
        this.institution &&
        this.institution.kl_assessment
      ) {
        this.$restful
          .Get("/evaluations2/dashboard_student_sections/")
          .then((response) => {
            this.sections_student = response.filter(
              (x) => !x.is_current_period
            );
            this.$emit(
              "count",
              this.sections_student.reduce(
                (acc, s) => acc + s.sections.length,
                0
              )
            );
          });
      }
    },
  },
  mounted() {
    this.getSectionStudent();
  },
  watch: {
    user() {
      this.getSectionStudent();
    },
    institution() {
      this.getSectionStudent();
    },
  },
  created() {
    this.$hasPermissions();
  },
};
</script>

<style scoped>
.container-title-my-classes {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dashboard-card {
  display: block;
  margin: 0;
}
.dashboard-card >>> .card-container {
  background: var(--kl-surface);
  border: 1px solid var(--kl-border-soft);
  border-radius: var(--kl-card-radius);
  box-shadow: 0 2px 4px rgba(16, 38, 73, 0.06);
  overflow: hidden;
}
.dashboard-card >>> .card-body {
  background: var(--kl-surface) !important;
  padding: 16px;
}
.card-header-icon {
  margin-right: 0.35em;
}
.border-table {
  border-radius: var(--kl-radius-lg);
  border: 1px solid var(--kl-border);
  max-height: calc(100vh - 290px) !important;
  overflow-y: auto;
}
.border-table >>> table {
  margin-bottom: 0;
}
.border-table >>> tbody tr:nth-child(even) > td {
  background-color: var(--kl-surface-muted);
}
.border-table >>> tbody tr:hover > td {
  background-color: var(--kl-surface-hover);
}
.primary-cell-my-classes {
  text-align: left;
  vertical-align: middle;
  background: var(--kl-color-accent-soft) !important;
  color: var(--kl-color-primary) !important;
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-caption);
  text-transform: uppercase;
  letter-spacing: var(--kl-ls-wide);
  padding: 11px 12px !important;
  border-bottom: none !important;
  white-space: nowrap;
}
.secondary-cell-my-classes {
  text-align: center;
  vertical-align: middle;
  color: var(--kl-text-body);
  font-size: var(--kl-fs-body);
  padding: 11px 12px !important;
  border-bottom: 1px solid var(--kl-border-soft) !important;
}
.div-href-test {
  color: var(--kl-color-primary);
  font-weight: var(--kl-fw-semibold);
  transition: color 0.2s ease;
}
.div-href-test:hover {
  color: var(--kl-color-primary-deep) !important;
  text-decoration: underline;
  cursor: pointer;
}
.container-matter-my-classes {
  align-items: center;
}
.container-btn-three-dots {
  max-width: 260px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.btn-three-dots {
  border-radius: 50%;
  padding: 2.5px 3px;
}
.btn-popover-my-classes {
  padding: 8px 12px !important;
  font-size: var(--kl-fs-body);
  border-radius: 9px !important;
  background: var(--kl-bg-page) !important;
  color: var(--kl-text-heading) !important;
  border: 1px solid var(--kl-border-soft) !important;
  text-align: left;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}
.btn-popover-my-classes:hover {
  background: linear-gradient(
    135deg,
    var(--kl-color-primary) 0%,
    var(--kl-color-secondary) 100%
  ) !important;
  color: #ffffff !important;
  border-color: transparent !important;
}
@media print {
  .secondary-cell-my-classes {
    background-color: transparent !important;
  }
}
</style>